// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2CEIZ","legacyBtn":"MutateMid_legacyBtn__X-nvf"};